import { Outlet } from 'react-router-dom';

import AdminGuard from '@/auth/guard/admin-guard';

import { userRoutes } from './users';
import { usMktRoutes } from './us-mkt';
import { teamRoutes } from './teams';
import { roleRoutes } from './roles';
import { bankRoutes } from './bank';

export const directoryRoutes = [
  {
    path: 'directory',
    element: (
      <AdminGuard hasContent>
        <Outlet />
      </AdminGuard>
    ),
    children: [...userRoutes, ...usMktRoutes, ...teamRoutes, ...roleRoutes, ...bankRoutes],
  },
];
